<template>
  <v-app>
    <h1 v-text="errorMessage" />
    <NuxtLink to="/">
      Home page
    </NuxtLink>
  </v-app>
</template>

<script>
const PAGE_NOT_FOUND = '404 Not Found'
const UNKNOWN_ERROR = 'An error occurred'

export default {
  layout: 'empty',
  props: {
    error: {
      type: Object,
      default: null
    }
  },
  head: ctx => ({ title: ctx.errorMessage }),
  computed: {
    errorMessage: ({ error }) => error.statusCode === 404 ? PAGE_NOT_FOUND : UNKNOWN_ERROR
  }
}
</script>

<style scoped>
h1 {
  font-size: 20px;
}
</style>
